module.exports = __webpack_public_path__ + "static/media/txt.89832898.svg";